export const isSignedUrlExpired = (signedUrl: string): boolean => {
  try {
    const url = new URL(signedUrl);
    const amzDate = url.searchParams.get('X-Amz-Date');
    const expiresInSeconds = parseInt(
      url.searchParams.get('X-Amz-Expires') ?? '',
      10,
    );

    if (!amzDate || isNaN(expiresInSeconds))
      throw new Error('Invalid URL parameters');

    const signedAt = new Date(
      Date.UTC(
        parseInt(amzDate.slice(0, 4), 10),
        parseInt(amzDate.slice(4, 6), 10) - 1,
        parseInt(amzDate.slice(6, 8), 10),
        parseInt(amzDate.slice(9, 11), 10),
        parseInt(amzDate.slice(11, 13), 10),
        parseInt(amzDate.slice(13, 15), 10),
      ),
    );

    const expiration = new Date(signedAt.getTime() + expiresInSeconds * 1000);
    if (isNaN(expiration.getTime())) throw new Error('Invalid expiration date');

    return new Date() >= expiration;
  } catch {
    console.warn('署名付きURLの有効期限検証失敗');
    return true;
  }
};
